import * as api from '../contactApi';
import { businessEntityActionCreators } from '../../businessEntity';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import { contactActionCreators, ContactActionKeys, FetchContacts } from '..';
import { contactsLoaded } from '../../businessEntity/businessEntitySelectors';

function* fetchContactsSaga(action: FetchContacts) {
  const loaded: boolean = yield select(contactsLoaded, action.payload);

  if (!loaded) {
    yield put(businessEntityActionCreators.setLoadingContacts([action.payload]));

    const contacts = yield call(api.fetchContacts, action.payload);

    yield put(contactActionCreators.fetchContactsFulfilled(contacts));
    yield put(businessEntityActionCreators.addContacts(contacts));
    yield put(businessEntityActionCreators.setLoadedContacts([action.payload]));
    yield put(businessEntityActionCreators.disableLoadingContacts([action.payload]));
  }
}

export function* watchFetchContacts() {
  yield takeEvery(ContactActionKeys.FETCH_CONTACTS, fetchContactsSaga);
}
